export enum PassStatus{
    ACTIVATE = "ACTIVATE",
    DEACTIVATE = "DEACTIVATE",
    CHANGEPASS = "CHANGEPASS"
}